import { CustomerOptOutModel } from './customer-opt-out.model';
import { NotificationCategoryModel } from './notification-category.model';

export class NotificationSettingModel
{
    public notification_category_id: string;
    public notification_category: NotificationCategoryModel;
    public customer_opt_outs: Array<CustomerOptOutModel>;
    public email: boolean;
    public email_opt_out: CustomerOptOutModel;
    public sms: boolean;
    public sms_opt_out: CustomerOptOutModel;
    public phone: boolean;
    public phone_opt_out: CustomerOptOutModel;
}
